<template>
    <div>
        <modal-add-service-field ref="addServiceFieldDialog" :item="this.id"/>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col cols="12">
                    <v-card>
                        <v-card-title>Dodatkowe pola</v-card-title>
                        <v-card-text>
                            <v-btn @click="showAddFieldModal()">Dodaj pole</v-btn>
                            <v-form class="mt-4" ref="categoryServicesForm">
                                <div v-if="fields">
                                    <v-data-table
                                        :headers="fieldHeaders"
                                        :items="fields"
                                        v-sortable-data-table
                                        @sorted="saveServiceFieldOrder"
                                        item-key="name"
                                    >
                                        <template v-slot:item.name="{ item }">
                                            <v-col cols="12" sm="12" md="8" lg="6">
                                                <input v-model="item.id" hidden/>
                                                <v-text-field
                                                    v-model="item.name"
                                                    class="pt-0"
                                                    label="Nazwa pola"
                                                    placeholder=" "
                                                ></v-text-field>
                                                <v-select
                                                    v-model="item.width"
                                                    :items="widths"
                                                    label="Szerokość"
                                                ></v-select>
                                                <v-select
                                                    v-model="item.type"
                                                    @change="fieldTypeChanged(item)"
                                                    :items="fieldTypes"
                                                    label="Typ"
                                                ></v-select>
                                                <v-text-field
                                                    v-if="item.type === 'select'"
                                                    v-model="item.options"
                                                    class="pt-0"
                                                    hint="Oddziel opcje przecinkiem np. gotówka,przelew"
                                                    label="Opcje"
                                                    placeholder=" "
                                                ></v-text-field>
                                                <v-checkbox
                                                    v-model="item.availableWithTransport"
                                                    label="Widoczne w ofertach z transportem"
                                                >Widoczne w ofertach z transportem
                                                </v-checkbox>
                                                <v-checkbox
                                                    v-model="item.availableWithoutTransport"
                                                    label="Widoczne w ofertach bez transportu"
                                                >Widoczne w ofertach bez transportue
                                                </v-checkbox>
                                                <v-checkbox
                                                    v-model="item.isRequired"
                                                    label="Jest wymagane"
                                                >Jest wymagane
                                                </v-checkbox>
                                                <v-btn @click="deleteField(item.id)">Usuń</v-btn>
                                                <v-btn @click="saveField(item.id, item)">Zapisz</v-btn>
                                            </v-col>
                                        </template>
                                    </v-data-table>
                                    <v-btn @click="$router.go(-1)">
                                        Powrót
                                    </v-btn>
                                </div>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
        <modal-loader :show="loading"/>
    </div>
</template>

<script>
import api from '../services/api';
import permissions from "@/mixins/permissions";
import ModalLoader from "../components/ModalLoader";
import ModalAddServiceField from "../components/ModalAddServiceField";
import Sortable from "sortablejs";

export default {
    components: {
        ModalLoader,
        ModalAddServiceField,
    },
    mixins: [
        permissions,
    ],
    props: ['id'],
    data() {
        return {
            loading: false,
            loadingDetails: false,
            fields: [],
            fieldTypes: ['input', 'textarea', 'datetime', 'select', 'file'],
            widths: Array.from({length: 12}, (_, i) => i + 1),
            fieldHeaders: [
                {
                    text: 'Pole',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
            ],
        }
    },
    methods: {
        async showAddFieldModal() {
            this.$refs.addServiceFieldDialog
                .open()
        },
        async loadFields() {
            if (this.loadingFields) {
                return;
            }

            this.loadingFields = true;

            let response;

            try {
                response = await api.get(`/api/service-field/${this.id}`);
            } catch (error) {
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się wczytać pól.',
                    error,
                });

                return;
            }

            this.loadingFields = false;

            this.fields = response.data.fields;
        },
        saveServiceFieldOrder(event) {
            const movedItem = this.fields.splice(event.oldIndex, 1)[0];
            this.fields.splice(event.newIndex, 0, movedItem);

            let request = [];

            this.fields.forEach((field, index) => {
                request.push({
                    id: field.id,
                    position: index,
                });
            });

            api
                .put('/api/service-field/position', {fields: request})
                .catch((error) => {
                    console.error('Error when adding a dimension:', error);
                    this.$root.$emit('notifyError', {
                        html: 'Wystąpił błąd.',
                    });
                })
        },
        async saveField(id, field) {
            this.loading = true;

            try {
                await api.put(`/api/service-field/${id}`, field);
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się zapisać pola.',
                    error
                });

                return;
            }

            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Pole zostało zaktualizowane.'
            });
        },
        async deleteField(id) {
            this.loading = true;

            try {
                await api.delete(`/api/service-field/${id}`);
            } catch (error) {
                /** @see https://github.com/axios/axios#handling-errors */
                this.loading = false;
                this.$root.$emit('notifyError', {
                    html: 'Nie udało się usunąć pola.',
                    error
                });

                return;
            }

            await this.loadFields();
            this.loading = false;
            this.$root.$emit('notifySuccess', {
                html: 'Pole zostało usunięte.'
            });
        },
        fieldTypeChanged(field) {
            if (field.type !== 'select') {
                field.options = null;
            }
        }
    },
    computed: {
        draggableParagraphs: {
            get() {
                return this.pageDetails.text.p
            },
            set(val) {
                this.pageDetails.text.p = val
            }
        }
    },
    directives: {
        sortableDataTable: {
            bind(el, binding, vnode) {
                const options = {
                    animation: 150,
                    onUpdate: function (event) {
                        vnode.child.$emit('sorted', event)
                    }
                }
                Sortable.create(el.getElementsByTagName('tbody')[0], options)
            }
        }
    },
    async created() {
        try {
            await this.loadFields();
        } catch (e) {
            void (0);
        }
    },
    beforeRouteUpdate(to, from, next) {
        next(); // Update the URL in address bar.
        this.id = to.params.id; // Store new user id in the local variable.
    },
}
</script>

<style scoped>
</style>
